import Operation from "../index.js";

export default {
    //首页获取数据列表
    worksList(params, fn) {
        let { type, institutionId } = params;
        Operation.Http.post(`/community/worksList?sortName=${type}&institutionId=${institutionId}`, null, fn);
    },
    //发现作品页类型导航渲染
    worksTypeList(fn) {
        Operation.Http.post(`/community/worksTypeList`, null, fn);
    },
    //点击类型切换
    worksListByType(params, fn) {
        Operation.Http.post(`/community/worksListByType`, params, fn);
    },
    //详情页
    worksDetailsById(id, fn) {
        Operation.Http.post(`/community/worksDetailsById?id=${id}`, null, fn);
    },
    //作品评论列表
    worksDiscussionList(id, fn) {
        Operation.Http.post(`/community/worksDiscussionList?worksId=${id}`, null, fn);
    },
    //作品详情页点赞
    likeWords(id, fn) {
        Operation.Http.post(`/community/likeWords?id=${id}`, null, fn);
    },
    //作品详情页取消点赞
    cancelLikeWorks(id, fn) {
        Operation.Http.post(`/community/cancelLikeWorks?id=${id}`, null, fn);
    },
    //作品详情页收藏
    collectWorks(id, fn) {
        Operation.Http.post(`/community/collectWorks?id=${id}`, null, fn);
    },
    //作品详情页取消收藏
    cancelCollectWorks(id, fn) {
        Operation.Http.post(`/community/cancelCollectWorks?id=${id}`, null, fn);
    },
    //作品评论
    saveDiscussion(params, fn) {
        Operation.Http.post(`/community/saveDiscussion`, params, fn);
    },
    //删除评论
    deleteDiscussion(id, fn) {
        Operation.Http.post(`/community/deleteDiscussion?id=${id}`, null, fn);
    },
    //回复
    saveComment(params, fn ) {
        Operation.Http.post(`/community/saveComment`, params, fn);
    },
    //我的作品
    myWorksList(params, fn) {
        Operation.Http.post(`/community/myWorksList`, params, fn);
    },
    //个人主页
    pageInfo(id, fn) {
        Operation.Http.post(`/community/pageInfo?authorId=${id}`, null, fn);
    },
    //发布的作品
    publishWorksList(params, fn) {
        Operation.Http.post(`/community/publishWorksList`, params, fn);
    },
    //赞过的作品
    likeWorksList(params, fn) {
        Operation.Http.post(`/community/likeWorksList`, params, fn);
    },
    //收藏的作品
    favoritesList(params, fn) {
        Operation.Http.post(`/community/favoritesList`, params, fn);
    },
    //个人主页点赞
    likeHomePage(id, fn) {
        Operation.Http.post(`/community/likeHomePage?authorId=${id}`, null, fn);
    },
    //个人主页取消点赞
    cancelLikeHomePage(id, fn) {
        Operation.Http.post(`/community/cancelLikeHomePage?authorId=${id}`, null, fn);
    },
    //关注
    follow(id, fn) {
        Operation.Http.post(`/community/follow?authorId=${id}`, null, fn);
    },
    //取消关注
    deleteFollow(id, fn) {
        Operation.Http.post(`/community/deleteFollow?authorId=${id}`, null, fn);
    },
    //删除作品
    deleteWorks(id, fn) {
        Operation.Http.post(`/community/deleteWorks?id=${id}`, null, fn)
    },
    //用户注册
    userRegister(params, fn) {
        Operation.Http.post(`/community/userRegister`, params, fn)
    },
    //添加Python作品
    savePythonWorks(params, fn) {
        Operation.Http.post(`/community/savePythonWorks`, params, fn)
    },
    // 查询作品
    findWorksById(id, fn) {
        Operation.Http.post(`/community/findWorksById?id=${id}`, null, fn)
    },
    //社区学员待上课表
    stuClassSchedule(params, fn) {
        Operation.Http.post(`/community/stuClassSchedule?${params.type? 'isLessonType='+ params.type : ''}${params.onlineTeaching? '&onlineTeaching='+ params.onlineTeaching : ''}`, null, fn)
    },
    //班级码上课
    attendClassByClassCode(id, fn) {
        // Operation.Http.post(`/community/attendClassByClassCode?classCode=${code}`, null, fn)
        Operation.Http.post(`/community/attendClassByClassCode?scheduleId=${id}`, null, fn)
    },
    loginToCpa(fn){
        Operation.Http.post(`/community/loginToCPAT`,null,fn)
    },
    //报名作品
    applyWorks(params, fn) {
        Operation.Http.post(`/community/applyWorks`, params, fn)
    },
    //投票
    voteWords(id, fn) {
        Operation.Http.post(`/community/voteWords?id=${id}`, null, fn)
    },
    // 评分
    reviewWords(params, fn) {
        Operation.Http.post(`/community/reviewWords`, params, fn)
    },
}


// WEBPACK FOOTER //
// ./src/request/api/community.js